import { client } from '../providers/data/client'
import { api2pdfclient } from '../providers/data/api2pdfclient'

export const assignKits = async (orders, notify) => {
  notify(`Assigning Kits to Orders ...`, {
    type: 'info',
    undoable: false,
    multiLine: true,
  })

  const orderIds = orders.map((order) => order.orderId)
  const expirationDate = localStorage.getItem('mfh-lot-expiration')

  try {
    const response = await client().post(`/orders/assignKits`, { orderIds: orderIds, expirationDate: expirationDate })
    const result = response.data

    let successMessage = `📊 Summary:\n`
    successMessage += `• Orders processed: ${result.summary.totalOrders}\n`
    successMessage += `• Orders successful: ${result.summary.successfulOrders}\n`
    successMessage += `• Orders failed: ${result.summary.failedOrders}\n`
    successMessage += `• Kit operations: ${result.summary.totalKitOperations}\n`
    successMessage += `• Successful kit operations: ${result.summary.successfulKitOperations}\n`
    successMessage += `• Failed kit operations: ${result.summary.failedKitOperations}\n\n`

    if (result.kitResults.successful.length > 0) {
      successMessage += `✅ Successful Kit Operations:\n`
      result.kitResults.successful.forEach((kit) => {
        successMessage += `• ${kit.message}\n`
      })
      successMessage += `\n`
    }

    if (result.kitResults.failed.length > 0) {
      successMessage += `❌ Failed Kit Operations:\n`
      result.kitResults.failed.forEach((kit) => {
        successMessage += `• ${kit.message}\n`
      })
      successMessage += `\n`
    }

    if (result.orderResults.failed.length > 0) {
      successMessage += `🚫 Failed Orders:\n`
      result.orderResults.failed.forEach((order) => {
        successMessage += `• Order ${order.orderId}: ${order.error}\n`
      })
    }

    const notificationType = result.summary.failedOrders > 0 || result.summary.failedKitOperations > 0 ? 'warning' : 'success'

    notify(successMessage, {
      type: notificationType,
      undoable: false,
      multiLine: true,
    })
  } catch (error) {
    // Check if the error has a response object
    if (error.response) {
      // Log the response data
      console.log('Response data:', error.response.data)

      let errorMessage = `Kit Assignment Failed!\n\n`

      if (error.response.data.summary) {
        const result = error.response.data
        errorMessage += `📊 Summary:\n`
        errorMessage += `• Orders processed: ${result.summary.totalOrders}\n`
        errorMessage += `• Orders failed: ${result.summary.failedOrders}\n\n`

        if (result.kitResults && result.kitResults.failed.length > 0) {
          errorMessage += `❌ Failed Kit Operations:\n`
          result.kitResults.failed.forEach((kit) => {
            errorMessage += `• ${kit.message}\n`
          })
          errorMessage += `\n`
        }

        if (result.orderResults && result.orderResults.failed.length > 0) {
          errorMessage += `🚫 Failed Orders:\n`
          result.orderResults.failed.forEach((order) => {
            errorMessage += `• Order ${order.orderId}: ${order.error}\n`
          })
        }
      } else {
        errorMessage += `Error: ${error.response.data.errorMessage || error.response.data.message || 'An error occurred'}`
      }

      notify(errorMessage, {
        type: 'error',
        undoable: false,
        multiLine: true,
      })
    } else {
      // If there's no response object, log the entire error
      console.log('Error:', error)

      // Notify with a generic error message
      notify('An unexpected error occurred during kit assignment', {
        type: 'error',
        undoable: false,
        multiLine: true,
      })
    }
  }
}

export const createAllShippingLabels = async (orders, notify) => {
  notify(`Creating inbound and outbound labels for Orders`, {
    type: 'info',
    undoable: false,
    multiLine: true,
  })

  const orderIds = orders.map((order) => order.orderId)

  try {
    const response = await client().post(`/orders/createAllShippingLabels`, {
      orderIds,
    })

    const result = response.data

    if (result.instructions.length) {
      result.instructions.map((instruction) =>
        notify(`${instruction}`, {
          multiLine: true,
          type: 'success',
          undoable: false,
        })
      )
    }

    // Build summary message
    let summaryMessage =
      `${result.inboundLabelsCreated} inbound shipping label(s) are ready to print\n${result.outboundLabelsCreated} outbound shipping label(s) are ready to print`

    // Report any failed orders
    if (result.failedOrders && result.failedOrders.length > 0) {
      summaryMessage += `\n\n❌ Failed Orders:\n`
      result.failedOrders.forEach((fo) => {
        summaryMessage += `• Order ${fo.orderId}: ${fo.error}\n`
      })
    }

    // Report any failed kits
    if (result.failedKits && result.failedKits.length > 0) {
      summaryMessage += `\n\n❌ Failed Kit Labels:\n`
      result.failedKits.forEach((fk) => {
        summaryMessage += `• Kit ${fk.kitId} (Order ${fk.orderId}): ${fk.error}\n`
      })
    }

    const hasFailures = (result.failedOrders && result.failedOrders.length > 0) ||
      (result.failedKits && result.failedKits.length > 0)

    notify(summaryMessage, {
      multiLine: true,
      type: hasFailures ? 'warning' : 'success',
      undoable: false,
    })
  } catch (error) {
    let errorMessage = 'Failed to create shipping labels.'

    if (error.response.data.message) {
      errorMessage = error.response.data.message
    } else if (error.response.data.error) {
      errorMessage = error.response.data.error
    } else if (error.message) {
      errorMessage = error.message
    }

    notify(errorMessage, {
      type: 'error',
      undoable: false,
      multiLine: true,
    })
  }
}


export const printAllShippingLabels = async (orders, notify) => {
  notify(
    `Getting reg labels and inbound/outbound shipping labels for ${orders.length > 1 ? orders.length : ''} Orders ${orders.length === 1 ? '#' + orders[0].shopifyOrderNumber : ''
    } ...`,
    {
      multiLine: true,
      type: 'info',
      undoable: false,
    }
  )

  const orderIds = orders.map((order) => order.orderId)

  try {
    const response = await client().post(`/orders/mergeAllShippingLabels`, { orderIds })

    const labelCount = response.data.inputPdfs.length
    const key = response.data.key

    if (labelCount > 10) {
      // Warn for "large" merges ...
      notify(`Merging ${labelCount} PDFs ...\nPLEASE WAIT! Do not refresh or close browser ... this may take up to 60 seconds!`, {
        type: 'info',
        undoable: false,
        multiLine: true,
      })
    }

    // Call Api2Pdf to merge these ...
    const endpoint = 'https://v2.api2pdf.com/pdfsharp/merge'
    const payload = {
      urls: response.data.inputPdfs,
      fileName: 'orders-mergedlabels.pdf',
      inline: false,
    }

    const result = await api2pdfclient().post(endpoint, payload, {
      headers: { Authorization: key },
    })

    // Open a window with a unique name based on current timestamp. Otherwise, browser
    // may not be able to find/use/open the previously opened window with the same title.
    let title = 'orders-mergedlabels-' + Date.now() + '.pdf'
    window.open(result.data.FileUrl, /* window title */ title)
  } catch (error) {
    let errorMessage = 'Failed to print shipping labels.'

    if (error.response.data.message) {
      errorMessage = error.response.data.message
    } else if (error.response.data.error) {
      errorMessage = error.response.data.error
    } else if (error.message) {
      errorMessage = error.message
    }

    notify(errorMessage, {
      type: 'error',
      multiLine: true,
      undoable: false,
    })
  }
}

export const markAsShipped = async (orders, notify, promptForTrackingEntryAtShopify = false, refresh) => {
  if (promptForTrackingEntryAtShopify) {
    // eslint-disable-next-line no-restricted-globals
    if (
      // eslint-disable-next-line no-restricted-globals
      !confirm(
        'The order(s) will be marked as "Fulfilled" in Shopify.\n\nIf you have manually shipped a package for this order,\nyou can also go to Shopify to enter a tracking number\nand notify the customer.\n\nProceed with marking order(s) as shipped?'
      )
    ) {
      // Canceled
      return false
    }
  }

  let messages = []

  let notifyMsg = `Marking ${orders.length > 1 ? orders.length : ''} Order ${orders.length === 1 ? '#' + orders[0].shopifyOrderNumber : ''
    } as Shipped/fulfilled.`
  // if (order.kitIds && order.kitIds.length) {
  //   notifyMsg += `Marking ${order.kitIds.length} Kit(s) as "Out To Patient" ...`
  // }
  // if (order.prepaidKitIds && order.prepaidKitIds.length) {
  //   notifyMsg += `Marking ${order.prepaidKitIds.length} Kit(s) as "Unregistered Prepaid" ...`
  // }

  notify(notifyMsg, {
    type: 'info',
    multiLine: true,
    undoable: false,
  })

  const orderIds = orders.map((order) => order.orderId)

  try {
    const response = await client().post(`/orders/markAsShipped`, { orderIds })
    messages = response.data.messages

    refresh()
    notify(messages.join('\n'), {
      type: 'success',
      undoable: false,
      multiLine: true,
    })
  } catch (error) {
    let errorMessage = 'Failed to mark as shipped.'

    if (error.response.data.message) {
      errorMessage = error.response.data.message
    } else if (error.response.data.error) {
      errorMessage = error.response.data.error
    } else if (error.message) {
      errorMessage = error.message
    }

    notify(errorMessage, {
      type: 'error',
      undoable: false,
      multiLine: true,
    })
  }
}

export const updateOrderStatus = async (orders, notify, refresh, status, statusLabel, promptForNote = true, providedNote = '') => {
  let noteToSave = providedNote

  // Only prompt if we supposedly need a note AND one wasn't provided
  if (promptForNote && !noteToSave) {
    // eslint-disable-next-line no-restricted-globals
    const note = prompt(
      `Enter a note for ${statusLabel.toLowerCase()} (optional):\n\nYou can leave this blank and click OK. Click Cancel to go back.`
    )
    if (note === null) return // User clicked Cancel
    noteToSave = note || ''
  }

  let notifyMsg = `Moving ${orders.length > 1 ? orders.length : ''} Order ${orders.length === 1 ? '#' + orders[0].shopifyOrderNumber : ''
    } to ${statusLabel}.`

  notify(notifyMsg, {
    type: 'info',
    multiLine: true,
    undoable: false,
  })

  try {
    // Update each order individually
    const updatePromises = orders.map((order) =>
      client().put(`/orders/${order.orderId}`, {
        status: status,
        notes: noteToSave,
        appendNotes: true,
      })
    )

    await Promise.all(updatePromises)

    refresh()
    notify(
      `Order${orders.length > 1 ? 's' : ''} ${orders.length === 1 ? '#' + orders[0].shopifyOrderNumber : ''
      } moved to ${statusLabel}${noteToSave ? ' with note' : ''}.`,
      {
        type: 'success',
        undoable: false,
        multiLine: true,
      }
    )
  } catch (err) {
    let errorMessage = 'Failed to move order(s) to ' + statusLabel.toLowerCase() + '.'

    if (err.response.data.message) {
      errorMessage = err.response.data.message
    } else if (err.response.data.error) {
      errorMessage = err.response.data.error
    } else if (err.message) {
      errorMessage = err.message
    }

    notify(errorMessage, {
      type: 'error',
      undoable: false,
      multiLine: true,
    })
  }
}

export const cancelOrder = async (orders, notify, refresh, cancellationReason, notifyCustomer = false) => {
  let notifyMsg = `Cancelling ${orders.length > 1 ? orders.length : ''} Order ${orders.length === 1 ? '#' + orders[0].shopifyOrderNumber : ''
    }.`

  notify(notifyMsg, {
    type: 'info',
    multiLine: true,
    undoable: false,
  })

  try {
    // Update each order individually
    const responses = await Promise.all(orders.map((order) =>
      client().put(`/orders/${order.orderId}`, {
        status: 'canceled',
        cancellationReason: cancellationReason,
        notifyCustomer: notifyCustomer,
      })
    ))

    refresh()

    // Check results
    let successCount = 0
    let notSentCount = 0
    let failureCount = 0

    responses.forEach(response => {
      const data = response.data
      if (data.shopifyCancellationStatus === 'notSent') notSentCount++
      else if (data.shopifyCancellationStatus === 'failed') failureCount++
      else successCount++ // 'canceled' or empty (if old order)
    })

    if (failureCount > 0) {
      notify(`Cancellation failed for ${failureCount} order(s) in Shopify. Check details.`, { type: 'warning', undoable: false, multiLine: true })
      if (successCount > 0) {
        setTimeout(() => notify(`${successCount} order(s) cancelled successfully.`, { type: 'success', undoable: false }), 2000)
      }
    } else if (notSentCount > 0) {
      notify(`${notSentCount} order(s) cancelled locally. Shopify cancellation SKIPPED (non-prod).`, { type: 'info', undoable: false, multiLine: true })
    } else {
      notify(
        `Order${orders.length > 1 ? 's' : ''} ${orders.length === 1 ? '#' + orders[0].shopifyOrderNumber : ''
        } cancelled successfully.`,
        {
          type: 'success',
          undoable: false,
          multiLine: true,
        }
      )
    }
  } catch (err) {
    let errorMessage = 'Failed to cancel order(s).'

    if (err.response.data.message) {
      errorMessage = err.response.data.message
    } else if (err.response.data.error) {
      errorMessage = err.response.data.error
    } else if (err.message) {
      errorMessage = err.message
    }

    notify(errorMessage, {
      type: 'error',
      undoable: false,
      multiLine: true,
    })
  }
}
